import { omit } from 'lodash-es';

export function initPanel(id, options = {}) {
  const panel = document.getElementById(id);
  if (panel) {
    window.Phoenix.panels[id] = new window.Toolkit.Panel(panel, options);
  }
}

export function destroyPanel(id) {
  if (Object.hasOwn(window.Phoenix.panels, id)) {
    window.Phoenix.panels[id].destroy();
  }
}

export function showPanel(id) {
  if (Object.hasOwn(window.Phoenix.panels, id)) {
    window.Phoenix.panels[id].show();
  }
}

export function closePanel(id) {
  if (Object.hasOwn(window.Phoenix.panels, id)) {
    window.Phoenix.panels[id].hide();
  }
}

export function closeAllPanels(exceptions = []) {
  Object.values(omit(window.Phoenix.panels, exceptions)).forEach((panel) => {
    if (panel && typeof panel.hide === 'function') {
      panel.hide();
    }
  });
}
